import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const AddTenderSettlement = () => {
    const [formData, setFormData] = useState({
        sno: '',
        against_bill_no: '',
        bill_date: '',
        tender_amount: '',
        pending: '',
        amount: '',
        charges: '',
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    // Handle input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        setError('');
        setSuccess('');

        // Validation
        const { sno, against_bill_no, bill_date, tender_amount, pending, amount, charges } = formData;
        if (!sno || !against_bill_no || !bill_date || !tender_amount || !pending || !amount || !charges) {
            setError('All fields are required.');
            return;
        }

        // Send POST request to API
        fetch(`${BASE_URL}tendersettlement`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setSuccess('Tender Settlement added successfully!');
                    setTimeout(() => navigate('/TenderSettlementList'), 2000); // Redirect after success
                } else {
                    setError('Failed to add Tender Settlement.');
                }
            })
            .catch((error) => {
                console.error('Error adding Tender Settlement:', error);
                setError('An error occurred. Please try again.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Tender Settlement</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">Tender Settlement Form</h4>
                    </div>
                    <div className="card-body">
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="sno" className="form-label">S.NO</label>
                                        <input
                                            type="number"
                                            id="sno"
                                            name="sno"
                                            className="form-control"
                                            value={formData.sno}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="against_bill_no" className="form-label">Against Bill No</label>
                                        <input
                                            type="text"
                                            id="against_bill_no"
                                            name="against_bill_no"
                                            className="form-control"
                                            value={formData.against_bill_no}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="bill_date" className="form-label">Bill Date</label>
                                        <input
                                            type="date"
                                            id="bill_date"
                                            name="bill_date"
                                            className="form-control"
                                            value={formData.bill_date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="tender_amount" className="form-label">Tender Amount</label>
                                        <input
                                            type="number"
                                            id="tender_amount"
                                            name="tender_amount"
                                            className="form-control"
                                            value={formData.tender_amount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pending" className="form-label">Pending</label>
                                        <input
                                            type="number"
                                            id="pending"
                                            name="pending"
                                            className="form-control"
                                            value={formData.pending}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className="form-control"
                                            value={formData.amount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="charges" className="form-label">Charges</label>
                                        <input
                                            type="number"
                                            id="charges"
                                            name="charges"
                                            className="form-control"
                                            value={formData.charges}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddTenderSettlement;
